// Адрес бэкенда. По умолчанию пусто: API и SignalR-хаб на том же домене, что и клиент
// (IIS проксирует /api и /hubs, в разработке — src/setupProxy.js). Cookie сессии
// работает только так: с API на другом адресе браузер её не отправит.
export const API_BASE_URL = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
